module.exports = {"data":{"page":{"id":"/opt/build/repo/content/pages/success/index.md absPath of file >>> MarkdownRemark","html":"<p>Thank you. We will connect with you shortly.</p>","frontmatter":{"title":"Success"}},"footnote":{"id":"/opt/build/repo/content/parts/footnote.md absPath of file >>> MarkdownRemark","html":"<ul>\n<li>Copyright © Appogeddon 2019</li>\n</ul>"},"site":{"siteMetadata":{"facebook":{"appId":""}}}},"pathContext":{"slug":"/success/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/success.json
// module id = 1317
// module chunks = 170786371021445